import { render } from "./dynamicItem.vue?vue&type=template&id=5fa4426c&scoped=true"
import script from "./dynamicItem.vue?vue&type=script&lang=js"
export * from "./dynamicItem.vue?vue&type=script&lang=js"

import "./dynamicItem.vue?vue&type=style&index=0&id=5fa4426c&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa4426c"]])

export default __exports__